import { useTranslation } from 'react-i18next';
import type { PlanType } from '../../types';

interface PlanBadgeProps {
  plan: PlanType;
  size?: 'sm' | 'md';
  granted?: boolean;
}

const planColors: Record<PlanType, string> = {
  free: 'bg-gray-100 text-gray-600',
  premium: 'bg-primary-50 text-primary-700',
  duo: 'bg-purple-50 text-purple-700',
};

export default function PlanBadge({ plan, size = 'sm', granted }: PlanBadgeProps) {
  const { t } = useTranslation('subscription');

  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-medium ${planColors[plan]} ${sizeClasses}`}>
      {t(`plans.${plan}`)}
      {granted && (
        <span className="text-[10px] opacity-60">({t('grant.info')})</span>
      )}
    </span>
  );
}
